import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import * as CustomPropTypes from 'lib/CustomPropTypes';

import LeadBorderTop from 'components/LeadBorderTop';
import TeasePicture from 'components/TeasePicture';
import Link from 'components/Link';
import Dek from 'components/Dek';
import RelatedContent from 'components/RelatedContent';
import Unibrow from 'components/Unibrow';
import AIMS_FLAVORS from 'lib/aimsFlavors';

function icon(item) {
  const { type } = item;

  switch (type) {
    case 'video':
      return <span className={classNames('standard-lead__icon', 'icon', 'icon-play')} />;

    case 'slideshow':
      return <span className={classNames('standard-lead__icon', 'icon', 'icon-gallery')} />;

    default:
      return null;
  }
}

function StandardLead(props) {
  const {
    content: { items, id: packageId, packageIndex },
    isRailAdjacent,
    pkgClassName,
  } = props;

  const [main] = items;
  if (!main) { return null; }

  const {
    unibrow, headline, dek, url,
  } = main.computedValues;
  const { related = [] } = items.length && main;

  // NOTE: this is not configurable as of BENTO-9299
  // can be added back to package definition with design signoff
  const { showTeaseImage } = main.metadata || {};
  const noImage = showTeaseImage === false;

  return (
    <section
      data-packageid={packageId}
      className={classNames(
        pkgClassName,
        `pkg-index-${packageIndex + 1}`,
        'standard-lead',
        { 'standard-lead--no-image': noImage },
      )}
    >
      <div data-contentid={items[0].id}>
        <LeadBorderTop types={['collectionLead']} />
        {!noImage && (
          <Link to={url} className={classNames('standard-lead__picture', 'relative')}>
            <TeasePicture
              responsiveFlavors={{
                s: AIMS_FLAVORS.FOCAL_760x380,
                m: AIMS_FLAVORS.FOCAL_1000x500,
                l: AIMS_FLAVORS.FOCAL_600x300,
                xl: AIMS_FLAVORS.FOCAL_1000x500,
              }}
              type={main.type}
              computedValues={main.computedValues}
              placeholder
            />
          </Link>
        )}
        <div className="standard-lead__info">
          {showTeaseImage !== false && icon(main)}
          <Unibrow
            className="standard-lead__eyebrow"
            unibrow={unibrow}
          />
          <h2 className="standard-lead__title">
            <Link to={url}>
              {headline}
            </Link>
          </h2>
          <Dek
            dek={dek}
          />
          <RelatedContent
            isRailAdjacent={isRailAdjacent}
            pkgClassName={pkgClassName}
            related={related}
          />
        </div>
      </div>
    </section>
  );
}

StandardLead.propTypes = {
  content: CustomPropTypes.package.isRequired,
  isRailAdjacent: PropTypes.bool,
  pkgClassName: PropTypes.string,
};

StandardLead.defaultProps = {
  isRailAdjacent: false,
  pkgClassName: 'pkg standardLead',
};

export default StandardLead;
